import useJsonApi from "lib/useJsonApi.js";

function useSessionProducts(sessionUuid) {
  return useJsonApi({
    url: `/api/session/${encodeURIComponent(sessionUuid)}/products`,
  });
}

export default useSessionProducts;
